import { history } from 'lib';
import { URLS_CONFIG } from 'config';

export default ({
  url = URLS_CONFIG.auth.signin,
  length = 1,
} = {}) => (history.length < length
  ? history.push(url)
  : history.goBack());
